import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';

export default class PopularCard extends PureComponent {
  handleClick = () => {
    sendDataLayerEvent('Click', {
      pageModule: 'Most Popular',
      linkType: 'article',
      linkTitle: this.props.title,
      linkHeadline: this.props.title,
      linkURL: this.props.url_full,
      // linkUID: '', cannot set because it is not in the API response
      itemName: this.props.title,
      itemIndex: this.props.indexWithinRow - 1
    });

    sendAnalyticsEvent(
      'R29 Most Popular',
      'Click',
      this.props.indexWithinRow
    );
  };

  render() {
    const { title, url, indexWithinRow, category } = this.props;

    return (
      <div className="popular-card card">
        <Link to={url} onClick={this.handleClick} className="popular-link">
          <div className = "popular-rank">
            {indexWithinRow}
          </div>
          <div className="popular-category"
            dangerouslySetInnerHTML={{ __html: category }}
          />
          <div className="title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </Link>
      </div>
    );
  }
}

PopularCard.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  opener_images: PropTypes.array.isRequired,
  indexWithinRow: PropTypes.number,
  category: PropTypes.string,
  className: PropTypes.string,
  url_full: PropTypes.string.isRequired
};
